import Config from '@config';
import { initializeSeasonTypesApi } from '@gasbi/shared/common/features/seasonTypes';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

const seasonTypes = initializeSeasonTypesApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

export const { seasonTypesApi, useGetSeasonTypesQuery } = seasonTypes;
